import { useState, useEffect } from "react";
import { FaRegHeart, FaRegComment, FaShare, FaUser, FaEllipsisH, FaTrash, FaEdit, FaHeart, FaTimes, FaPaperPlane } from "react-icons/fa";
import { post as postRequest, get, deleteRequest, patchRequest } from "../http/api";
import { useRef } from "react";
import { useConfirmModal } from "../components/reusable/ConfirmModalContext";
import { useNavigate } from "react-router-dom";
import PostComments from "./PostComments";
import { useTranslation } from "react-i18next";
import { API_URL, UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";
import { createPortal } from "react-dom";
import VerifiedBadge from "../components/reusable/VerifiedBadge";
import PostModal from "./PostModal";


export default function Post({ post, id_user, fetchPosts, openComments = false, scrollToLastComment = false, isModal = false, priority = false }) {

  const currentUserId = sessionStorage.getItem("id_user");

  const navigate = useNavigate();

  const menuRef = useRef(null);

  const { openConfirmModal, closeModal } = useConfirmModal();

  const { t } = useTranslation();

  const commentListRef = useRef(null);

  const [showFullPostText, setShowFullPostText] = useState(false);

  const [likes, setLikes] = useState(post.likes || 0);
  const [liked, setLiked] = useState(post.isLiked === 1);

  const [comments, setComments] = useState(post.comments || 0);
  const [shares, setShares] = useState(post.shares || 0);
  const [showComments, setShowComments] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [publishedCommentId, setPublishedCommentId] = useState(null);
  const [showCommentPanel, setShowCommentPanel] = useState(false);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editedText, setEditedText] = useState(post.text || "");
  const [isFollowing, setIsFollowing] = useState(post.isFollowing === 1);
  const [followJustDone, setFollowJustDone] = useState(false);

  const [showMenu, setShowMenu] = useState(false);
  const isOwner = parseInt(post.id_user) === parseInt(currentUserId);

  // Modal pour le partage d un post
  const [showShareModal, setShowShareModal] = useState(false);
  const [matches, setMatches] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [shareError, setShareError] = useState("");


  const [shareToast, setShareToast] = useState(false);
  const [openedPostId, setOpenedPostId] = useState(null);

  // fonction de partage de post
  const handleSharePost = async () => {

    if (selectedUsers.length === 0) {
      setShareError(t("post.selectRecipient"));
      return;
    }

    try {

      for (let userId of selectedUsers) {

        await postRequest(
          "messages",
          {
            receiver_id: userId,
            type: "post",
            post_id: post.id_post
          }
        );

      }

      await postRequest(
        `posts/${post.id_post}/share`,
        {
          count: selectedUsers.length
        }
      );

      setShares(
        prev => prev + selectedUsers.length
      );

      setShowShareModal(false);
      setSelectedUsers([]);
      setShareError("");
      setShareToast(true);
      setTimeout(() => {
        setShareToast(false);
      }, 2500);

    }
    catch (err) {
      console.error(err);
    }
  };

  const closeShareModal = () => {
    setShowShareModal(false);
    setSelectedUsers([]);
    setShareError("");
  };


  // fermeture dropdown
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // fonction follow
  const handleFollow = async () => {
    try {
      await postRequest(`follows/${post.id_user}`);
      setIsFollowing(true);

      //  animation "Suivi"
      setFollowJustDone(true);

      setTimeout(() => {
        setFollowJustDone(false);
      }, 5000);

    } catch (err) {
      console.error(err);
    }
  };

  // stats pour modifier commentaire
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editedCommentText, setEditedCommentText] = useState("");

  // fonction pour modifier commentaire
  const handleEditComment = (c) => {
    setEditingCommentId(c.id_comment);
    setEditedCommentText(c.comment);
  };

  // fonction pour confirmation de suppression d un commentaire
  const confirmDeleteComment = (id_comment) => {
    openConfirmModal({
      title: t("post.deleteCommentTitle"),
      message: t("post.deleteCommentMessage"),
      confirmText: t("post.delete"),
      variant: "danger",
      cancelText: t("post.cancel"),
      onConfirm: async () => {
        await handleDeleteComment(id_comment);
        closeModal();
      },
    });
  };

  // modif instantannée pour réponse
  const updateCommentText = (comments, id_comment, newText) => {
    return comments.map(c => {

      //  si trouvé
      if (c.id_comment === id_comment) {
        return {
          ...c,
          comment: newText
        };
      }

      //  recursion dans replies
      if (c.replies && c.replies.length > 0) {
        return {
          ...c,
          replies: updateCommentText(c.replies, id_comment, newText)
        };
      }

      return c;
    });
  };

  // stats pour répondre a un commentaire
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyingUser, setReplyingUser] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [expandedReplies, setExpandedReplies] = useState({});

  // fonction pour répondre a un commentaire
  const handleReply = async (id_comment) => {
    if (!replyText.trim()) return;

    const finalText = replyingUser
      ? `@${replyingUser} ${replyText}`
      : replyText;

    await postRequest(
      `posts/${post.id_post}/comments`,
      {
        comment: finalText,
        parent_id: id_comment
      }
    );

    setReplyText("");
    setReplyingTo(null);
    setReplyingUser(null);


    fetchComments();
    setComments(prev => prev + 1);
  };


  // useEffect pour le partage du post
  useEffect(() => {
    if (showShareModal) {
      fetchMatches();
    }
  }, [showShareModal]);

  const fetchMatches = async () => {
    try {
      const res = await get("matches");
      setMatches(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };


  const handleSaveComment = async (id_comment) => {
    try {
      await patchRequest(
        `posts/comments/${id_comment}`,
        { comment: editedCommentText }
      );

      setEditingCommentId(null);

      //  update
      setCommentsList(prev =>
        updateCommentText(prev, id_comment, editedCommentText)
      );

    } catch (err) {
      console.error(err);
    }
  };



  const handleEditPost = async () => {

    try {

      await patchRequest(
        `posts/${post.id_post}`,
        { text: editedText }
      );

      setShowEditModal(false);

      fetchPosts();

    } catch (err) {
      console.error(err);
    }

  };

  /* =============================
     FORMAT DATE
  ============================= */

  const formatDate = (dateString) => {

    if (!dateString) return "";

    const now = new Date();
    const postDate = new Date(dateString);

    const diff =
      Math.floor((now - postDate) / 1000);

    if (diff < 60) {
      return t("post.justNow");
    }

    if (diff < 3600) {
      return t(
        "post.minutesAgo",
        {
          count: Math.floor(diff / 60)
        }
      );
    }

    if (diff < 86400) {
      return t(
        "post.hoursAgo",
        {
          count: Math.floor(diff / 3600)
        }
      );
    }

    if (diff < 2592000) {
      const days = Math.floor(diff / 86400);

      if (days === 1) {
        return t("post.oneDay");
      }

      return t(
        "post.daysAgo",
        {
          count: days
        }
      );
    }

    const months = Math.floor(diff / 2592000);

    return t(
      months === 1 ? "post.oneMonth" : "post.monthsAgo",
      { count: months }
    );
  };

  /* =============================
     LIKE SYSTEM
  ============================= */

  const handleLike = async () => {
    try {
      const res = await postRequest(
        `posts/${post.id_post}/like`,
        {} // ne rien envoyer
      );

      if (!res || !res.data) return;

      setLiked(res.data.liked);

      setLikes(prev =>
        res.data.liked ? prev + 1 : prev - 1
      );

    } catch (err) {
      console.error(err);
    }
  };

  /* =============================
     COMMENTS SYSTEM
  ============================= */
  const updateCommentLike = (comments, id_comment, liked) => {
    return comments.map(c => {

      //  si c le bon commentaire
      if (c.id_comment === id_comment) {
        return {
          ...c,
          isLiked: liked ? 1 : 0,
          likes: liked
            ? (c.likes || 0) + 1
            : (c.likes || 0) - 1
        };
      }

      // si il a des replies → recursion
      if (c.replies && c.replies.length > 0) {
        return {
          ...c,
          replies: updateCommentLike(c.replies, id_comment, liked)
        };
      }

      return c;
    });
  };

  const handleLikeComment = async (id_comment) => {
    try {
      const res = await postRequest(
        `posts/comments/${id_comment}/like`,
        {}
      );

      if (!res || !res.data) return;

      setCommentsList(prev =>
        updateCommentLike(prev, id_comment, res.data.liked)
      );

    } catch (err) {
      console.error(err);
    }
  };

  const fetchComments = async () => {

    const scrollTop = commentListRef.current?.scrollTop;

    setCommentsLoading(true);

    const res = await get(`posts/${post.id_post}/comments`);
    setCommentsList(res.data || []);

    // pinned en premier
    const comments = Array.isArray(res?.data)
      ? res.data
      : [];

    const sorted = comments.sort((a, b) => {
      if (b.is_pinned !== a.is_pinned) {
        return b.is_pinned - a.is_pinned;
      }
      return new Date(a.created_at) - new Date(b.created_at);
    });

    setCommentsList(sorted);
    setComments(countAllComments(sorted));
    setCommentsLoading(false);

    setTimeout(() => {
      if (commentListRef.current) {
        commentListRef.current.scrollTop = scrollTop;
      }
    }, 0);
  };


  const removeCommentAndReplies = (comments, id_comment) => {
    return comments
      .filter(c => c.id_comment !== id_comment) // supprimer le parent
      .map(c => {
        if (c.replies && c.replies.length > 0) {
          return {
            ...c,
            replies: removeCommentAndReplies(c.replies, id_comment)
          };
        }
        return c;
      });
  };


  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    const res = await postRequest(
      `posts/${post.id_post}/comments`,
      { comment: newComment }
    );
    const commentId = res?.data?.id_comment;
    if (commentId) setPublishedCommentId(commentId);
    setNewComment("");
    setComments(prev => prev + 1);
    await fetchComments();
    if (commentId) {
      window.setTimeout(() => setPublishedCommentId(null), 3600);
    }
  };


  const handleDeleteComment = async (id_comment) => {
    await deleteRequest(`posts/comments/${id_comment}`);

    setCommentsList(prev =>
      removeCommentAndReplies(prev, id_comment)
    );
    setComments(prev => prev - 1);
  };


  const handleTogglePin = async (id_comment) => {

    await patchRequest(
      `posts/comments/${id_comment}/pin`
    );
    await fetchComments();
  };

  useEffect(() => {
    if (showCommentPanel) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showCommentPanel]);


  const handleDeletePost = async () => {
    try {
      await deleteRequest(`posts/${post.id_post}`);
      fetchPosts();
    } catch (err) {
      console.error(err);
    }
  };


  useEffect(() => {
    if (openComments) {
      setShowCommentPanel(true);
      fetchComments();
    }
  }, [openComments]);

  // fonction pour confirmation de suppression d un commentaire
  const confirmDeletePost = () => {
    openConfirmModal({
      title: t("post.deletePostTitle"),
      message: t("post.deletePostMessage"),
      confirmText: t("post.delete"),
      variant: "danger",
      cancelText: t("post.cancel"),
      onConfirm: async () => {
        await handleDeletePost();
        closeModal();
      },
    });
  };

  // Count comments
  const countAllComments = (comments) => {
    let count = 0;

    const traverse = (list) => {
      list.forEach(c => {
        count++; // le commentaire lui-même

        if (c.replies && c.replies.length > 0) {
          traverse(c.replies);
        }
      });
    };

    traverse(comments);
    return count;
  };


  // Fonction pour afficher tous les actions
  const renderReplyItem = (r) => (
    <div key={r.id_comment} className="reply-item">

      <div className="reply-content">
        <b className="comment-username-link" onClick={() => navigate(`/user/${r.username}`)}>{r.username}</b>
        <span className="comment-date">
          {formatDate(r.created_at)}
        </span>
      </div>

      {/* EDIT */}
      {editingCommentId === r.id_comment ? (
        <div className="edit-comment-box">
          <input
            value={editedCommentText}
            onChange={(e) => setEditedCommentText(e.target.value)}
          />

          <div className="edit-actions">
            <button onClick={() => setEditingCommentId(null)}>
              {t("post.cancel")}
            </button>

            <button onClick={() => handleSaveComment(r.id_comment)}>
              {t("post.save")}
            </button>
          </div>
        </div>
      ) : (
        <p>
          {r.comment.startsWith("@") && (
            <span className="mention">
              {r.comment.split(" ")[0]}
            </span>
          )}
          {" "}
          {r.comment.replace(/^@\w+\s/, "")}
        </p>
      )}

      {/*  ACTIONS */}
      <div className="reply-actions-row">

        {(parseInt(r.id_user) === parseInt(id_user) ||
          parseInt(post.id_user) === parseInt(id_user)) && (
            <button onClick={() => confirmDeleteComment(r.id_comment)}>
              {t("post.delete")}
            </button>
          )}

        {parseInt(r.id_user) === parseInt(id_user) && (
          <button onClick={() => handleEditComment(r)}>
            {t("post.edit")}
          </button>
        )}

        <button
          onClick={() => {
            setReplyingTo(r.id_comment);
            setReplyingUser(r.username);
          }}
        >
          {t("post.reply")}
        </button>
      </div>

      {/*  LIKE */}
      <div className="comment-like-section">
        <button
          className={`like-comment ${Number(r.isLiked) === 1 ? "liked" : ""}`}
          onClick={() => handleLikeComment(r.id_comment)}
        >
          <FaHeart size={14} />
        </button>

        <span className="like-count">
          {r.likes || 0}
        </span>
      </div>

      {/* INPUT REPLY */}
      {replyingTo === r.id_comment && (
        <div className="reply-box">
          <input
            placeholder={t(
              "post.replyTo",
              {
                username: replyingUser
              }
            )}
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
          />

          <div className="reply-actions">
            <button onClick={() => setReplyingTo(null)}>
              {t("post.cancel")}
            </button>

            <button onClick={() => handleReply(r.id_comment)}>
              {t("post.reply")}
            </button>
          </div>
        </div>
      )}

      {/*  RECURSION */}
      {r.replies && r.replies.length > 0 && (
        <div >
          {r.replies.map(renderReplyItem)}
        </div>
      )}

    </div>
  );

  if (isModal) {
    return (
      <div className="instagram-post-layout">

        <div className="instagram-left">

          {post.image && (
            <img alt="" className="instagram-main-media" src={getMediaUrl(post.image)} />

          )}

          {post.video && (
            <video controls className="instagram-main-media" src={getMediaUrl(post.video, "video")} />
            // <video
            //   controls
            //   className="instagram-main-media"
            //   src={
            //     post.video.startsWith("http")
            //       ? post.video
            //       : `${UPLOADS_URL}/videos/${post.video}`
            //   }
            // />
          )}

        </div>

        <div className="instagram-right">

          <div className="instagram-post-header">
            <img
              // src={`${API_URL}${post.user_photo}`}
              src={getMediaUrl(post.user_photo)}
              alt=""
            />
            <strong>{post.username}</strong>
          </div>

          <PostComments
            highlightedCommentId={publishedCommentId}
            showCommentPanel={true}
            setShowCommentPanel={() => { }}
            commentListRef={commentListRef}
            commentsLoading={commentsLoading}
            commentsList={commentsList}
            formatDate={formatDate}
            editingCommentId={editingCommentId}
            editedCommentText={editedCommentText}
            setEditedCommentText={setEditedCommentText}
            setEditingCommentId={setEditingCommentId}
            handleSaveComment={handleSaveComment}
            id_user={id_user}
            post={post}
            confirmDeleteComment={confirmDeleteComment}
            handleTogglePin={handleTogglePin}
            handleEditComment={handleEditComment}
            replyingTo={replyingTo}
            replyingUser={replyingUser}
            setReplyingTo={setReplyingTo}
            setReplyingUser={setReplyingUser}
            replyText={replyText}
            setReplyText={setReplyText}
            handleReply={handleReply}
            expandedReplies={expandedReplies}
            setExpandedReplies={setExpandedReplies}
            handleLikeComment={handleLikeComment}
            renderReplyItem={renderReplyItem}
            newComment={newComment}
            setNewComment={setNewComment}
            handleAddComment={handleAddComment}
            FaHeart={FaHeart}
            scrollToLastComment={scrollToLastComment}
          />

        </div>

      </div>
    );
  }


  return (
    <div className="post" >

      <div className="post-header">

        {/* LEFT SIDE */}
        <div className="post-header-left">
          {post.user_photo ? (
            <img
              src={getMediaUrl(post.user_photo)}
              // src={`${API_URL}${post.user_photo}`}
              alt={post.username || t("post.user")}
              className="post-user-avatar"
            />
          ) : (
            <FaUser className="post-user-icon" />
          )}

          <div className="post-user-info">
            {/* <b>{post.username || "Utilisateur"}</b> */}
            <b
              className="clickable-username"
              onClick={() => navigate(`/user/${post.username}`)}
            >
              {post.username || t("post.user")}
            </b>
            <VerifiedBadge verified={Number(post.is_verified) === 1} />
            <span className="post-time">
              &middot; {formatDate(post.created_at)}
            </span>
            {/* <span>• {formatDate(post.created_at)}</span> */}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="post-header-right">

          {/*  bouton suivre */}
          {!isOwner && (
            <>
              {!isFollowing && (
                <button onClick={handleFollow} className="follow-btn-post">
                  {t("post.follow")}
                </button>
              )}

              {isFollowing && followJustDone && (
                <button className="following-temp">
                  {t("post.following")}
                </button>
              )}
            </>
          )}

          {/* menu */}
          {isOwner && (
            <div className="post-menu-wrapper" ref={menuRef}>
              <FaEllipsisH
                className="post-menu-icon"
                onClick={() => setShowMenu(!showMenu)}
              />

              {showMenu && (
                <div className="post-menu-dropdown">
                  <button className="edit_btn_drop"
                    onClick={() => {
                      setShowEditModal(true);
                      setShowMenu(false);
                    }}>
                    <FaEdit size={12} />
                    {t("post.edit")}
                  </button>

                  <button onClick={confirmDeletePost}>
                    <FaTrash size={12} />
                    {t("post.delete")}
                  </button>
                </div>
              )}
            </div>
          )}

        </div>

      </div>
      {/* TEXT */}

      {post.text && (
        <div className="post-text-wrapper">

          <p className={`post-text ${showFullPostText ? "expanded" : "collapsed"}`}>
            {post.text}
          </p>

          {post.text.length > 180 && (
            <button
              className="post-see-more"
              onClick={() => setShowFullPostText(prev => !prev)}
            >
              {showFullPostText
                ? t("seeMore.hide")
                : t("seeMore.show")}
            </button>
          )}

        </div>
      )}
      {/* {post.text && <p className="post-text">{post.text}</p>} */}

      {/* IMAGE */}
      {post.image && (
        <img
          src={getMediaUrl(post.image)}
          alt="post"
          className="post-image"
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"
          onClick={() => {
            if (!document.documentElement.classList.contains("native-app")) {
              setOpenedPostId(post.id_post);
            }
          }}
        />
      )}

      {post.video && (
        <div className="post-video-container">
          <video
            src={getMediaUrl(post.video, "video")}
            controls
            preload="metadata"
          />
        </div>
      )}

      {/* LINK */}
      {post.link_url && (
        <a
          href={post.link_url}
          target="_blank"
          rel="noreferrer"
          className="post-link"
        >
          {post.link_url}
        </a>
      )}

      {/* ACTIONS */}
      <div className="post-actions">
        <button
          key={liked ? "post-liked" : "post-not-liked"}
          className={`post-like-btn ${liked ? "active just-liked" : ""}`}
          onClick={handleLike}
        >
          {liked ? <FaHeart /> : <FaRegHeart />}
          <span className="post-action-count">{likes}</span>
        </button>

        {/* COMMENTS */}
        <button onClick={() => {
          setShowCommentPanel(true);
          fetchComments();
        }}>
          <FaRegComment />
          <span className="post-action-count">{comments}</span>
        </button>


        {showComments && (
          <div className="comments-section">

            {commentsList.map((c) => (
              <div key={c.id_comment} className={`comment-item ${c.is_pinned ? "pinned" : ""}`}>
                <b className="comment-username-link" onClick={() => navigate(`/user/${c.username}`)}>{c.username}</b>
                <p>{c.comment}</p>
              </div>
            ))}

            <div className="comment-input">
              <input
                type="text"
                placeholder={t("post.writeComment")}
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
              <button onClick={handleAddComment}>
                {t("post.publish")}
              </button>
            </div>

          </div>
        )}


        <button onClick={() => setShowShareModal(true)}>
          <FaShare />
          <span className="post-action-count">{shares}</span>
        </button>
      </div>

      <PostComments
        highlightedCommentId={publishedCommentId}
        showCommentPanel={showCommentPanel}
        setShowCommentPanel={setShowCommentPanel}
        commentListRef={commentListRef}
        commentsLoading={commentsLoading}
        commentsList={commentsList}
        formatDate={formatDate}
        editingCommentId={editingCommentId}
        editedCommentText={editedCommentText}
        setEditedCommentText={setEditedCommentText}
        setEditingCommentId={setEditingCommentId}
        handleSaveComment={handleSaveComment}
        id_user={id_user}
        post={post}
        confirmDeleteComment={confirmDeleteComment}
        handleTogglePin={handleTogglePin}
        handleEditComment={handleEditComment}
        replyingTo={replyingTo}
        replyingUser={replyingUser}
        setReplyingTo={setReplyingTo}
        setReplyingUser={setReplyingUser}
        replyText={replyText}
        setReplyText={setReplyText}
        handleReply={handleReply}
        expandedReplies={expandedReplies}
        setExpandedReplies={setExpandedReplies}
        handleLikeComment={handleLikeComment}
        renderReplyItem={renderReplyItem}
        newComment={newComment}
        setNewComment={setNewComment}
        handleAddComment={handleAddComment}
        FaHeart={FaHeart}
        scrollToLastComment={scrollToLastComment}
      />


      {showEditModal && (

        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>

          <div
            className="modal edit-post-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <h3>{t("post.editPost")}</h3>

            {/* TEXTE */}

            <textarea
              value={editedText}
              onChange={(e) => setEditedText(e.target.value)}
              className="edit-textarea"
            />

            {/* MEDIA PREVIEW */}

            {post.image && (
              <img
                src={getMediaUrl(post.image)}
                className="edit-preview-image"
                alt=""
              />
            )}

            {post.video && (
              <div className="edit-preview-video">
                <video
                  src={getMediaUrl(post.video, "video")}
                  controls
                />
              </div>
            )}

            <div className="modal-actions">

              <button
                className="cancel"
                onClick={() => setShowEditModal(false)}
              >
                {t("post.cancel")}
              </button>

              <button
                className="publish"
                onClick={handleEditPost}
              >
                {t("post.save")}
              </button>

            </div>

          </div>

        </div>

      )}

      {showShareModal && createPortal(
        <div className="send-post-modal-overlay" onClick={closeShareModal}>

          <div
            className="send-post-modal send-post-share-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="send-post-share-header">
              <span><FaShare /></span>
              <div>
                <h3>{t("post.sharePost")}</h3>
                <p>{t("post.shareSubtitle")}</p>
              </div>
              <button type="button" className="send-post-share-close" onClick={closeShareModal} aria-label={t("post.cancel")}>
                <FaTimes />
              </button>
            </div>

            <div className="send-post-share-list">

              {matches.length === 0 ? (
                <p>{t("post.noMatch")}</p>
              ) : (

                matches.map(user => (
                  <div key={user.id} className="send-post-share-item">

                    <label>
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedUsers(prev => [...prev, user.id]);
                          } else {
                            setSelectedUsers(prev =>
                              prev.filter(id => id !== user.id)
                            );
                          }
                          setShareError("");
                        }}
                      />

                      {user.full_name}
                    </label>

                  </div>
                ))

              )}

            </div>

            {shareError && <p className="send-post-share-error">{shareError}</p>}

            <div className="send-post-modal-actions">

              <button onClick={closeShareModal}>
                {t("post.cancel")}
              </button>

              <button onClick={handleSharePost}>
                <FaPaperPlane /> {t("post.send")}
              </button>

            </div>

          </div>

        </div>
      , document.body)}


      {shareToast && (

        <div className="share-success-toast">

          <div className="share-success-icon">
            ✓
          </div>

          <div>

            <strong>
              {t("post.sharedTitle")}
            </strong>

            <p>
              {t("post.sharedSuccess")}
            </p>

          </div>

        </div>

      )}

      {openedPostId && (
        <PostModal
          postId={openedPostId}
          onClose={() => setOpenedPostId(null)}
        />
      )}

    </div>
  );
}
